module.exports = __webpack_public_path__ + "img/5.08c8784.svg";